import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import useMap from './useMap';
function MapZoomSelector() {
    const { zoom, setZoom } = useMap();
    const theme = useTheme();
    const updateMapZoom = React.useCallback((_, value) => {
        if (value === 'plus') {
            setZoom?.((zoom || 0) + 1);
        }
        else if (value === 'minus') {
            setZoom?.((zoom || 0) - 1);
        }
    }, [setZoom, zoom]);
    return (React.createElement(ToggleButtonGroup, { orientation: "vertical", color: "primary", exclusive: true, onChange: updateMapZoom, sx: { backgroundColor: theme.palette.background.paper } },
        React.createElement(ToggleButton, { value: "plus" },
            React.createElement(AddIcon, null)),
        React.createElement(ToggleButton, { value: "minus" },
            React.createElement(RemoveIcon, null))));
}
export default MapZoomSelector;
